import { useState } from "react";
import { ExternalLink, Store } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { CHANNELS } from "@/pages/QuickPastePanel";

const KEY = "snaplist.openSiteLast";
const SITES = { ebay: { name: "eBay", sellUrl: "https://www.ebay.com/sl/prelist/suggest", color: "#0053DA" }, ...CHANNELS };
const readLast = () => { try { return localStorage.getItem(KEY) || ""; } catch { return ""; } };

// Header button: open any marketplace's "list an item" page in a new tab, like the extension side panel's Open.
export default function OpenSiteMenu() {
  const [last, setLast] = useState(readLast);
  const keys = Object.keys(SITES).sort((a, b) => (b === last) - (a === last));
  const go = (k) => {
    try { localStorage.setItem(KEY, k); } catch { /* private mode */ }
    setLast(k);
    window.open(SITES[k].sellUrl, "_blank", "noopener");
  };
  return (
    <DropdownMenu onOpenChange={(v) => v && setLast(readLast())}>
      <DropdownMenuTrigger asChild>
        <button type="button" data-testid="open-site-menu" aria-label="Open a site to list on" title="Open a site to list on"
          className="inline-flex h-9 w-9 shrink-0 items-center justify-center gap-1.5 rounded-full border border-[#0053DA]/30 bg-[#0053DA]/5 text-xs font-semibold text-[#0053DA] transition-colors hover:bg-[#0053DA]/10">
          <Store className="h-4 w-4" /><span className="sr-only">List on a site</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="max-h-[70dvh] w-56 overflow-y-auto" data-testid="open-site-list">
        <DropdownMenuLabel className="text-[11px] font-normal text-slate-500">Opens the site's "list an item" page in a new tab</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {keys.map((k) => (
          <DropdownMenuItem key={k} onSelect={() => go(k)} className="cursor-pointer gap-2" data-testid={`open-site-${k}`}>
            <span className="h-2.5 w-2.5 shrink-0 rounded-full" style={{ background: SITES[k].color }} />
            <span className="flex-1">{SITES[k].name}</span>
            {k === last ? <span className="text-[10px] font-semibold uppercase tracking-wider text-slate-400" data-testid="open-site-last">Last used</span>
              : <ExternalLink className="h-3 w-3 text-slate-300" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
